// Pricing data per unit
const pricingData = {
  growing: 225,
  established: 550,
  starter: 49,
  premium: 99,
  enterprise: 249,
  admin: 75,
  sales: 55,
  field: 30,
  subcontractor: 20,
};

export default pricingData;
